import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  ToastContainer,
} from "react-bootstrap";
import Select from "react-select";
import {
  useGetVendorListMutation,
  useCreateSMSCRateMutation,
  useGetSmscForVendorMutation,
  useCountriesOptionsMutation,
} from "Services/services";
import "react-phone-input-2/lib/style.css";
import { Toast } from "react-bootstrap";
import { Routes } from "routes";
import { DropFilesForm } from "components/Forms";
import { useHistory } from "react-router-dom";

export default () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");

  // Get the usertype from localStorage
  const loggedUserData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(loggedUserData);

  const [network, setNetwork] = useState("");
  const [cost, setCost] = useState("");
  const [sprice, setSprice] = useState("");
  const [contCode, setContCode] = useState("");
  const [mcc, setMcc] = useState("");
  const [mnc, setMnc] = useState("");

  const [smscOptions, setSmscOptions] = useState([]);
  const [smscId, setSmscId] = useState("");

  const [users, setUsers] = useState([]);
  const [user, setUser] = useState(null);

  const [isManual, setIsManual] = useState(false);
  const [file, setFile] = useState();

  const [refreshFileField, setRefreshFileField] = useState(false);

  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [userDropDown] = useGetVendorListMutation();
  const [smscDropDown] = useGetSmscForVendorMutation();
  const [getCountries] = useCountriesOptionsMutation();

  const history = useHistory();

  // Validation states
  const [validated, setValidated] = useState(false);
  const [selectErrors, setSelectErrors] = useState({
    user: false,
    smscId: false,
    country: false,
    cost: false,
    sprice: false,
    contCode: false,
    network: false,
    mcc: false,
    mnc: false,
    file: false,
  });

  useEffect(() => {
    fetchUserDropdown();
    fetchSMSCDropdown();
    fetchCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSmscId("");
    setSmscOptions([]);
    if (!user || user === "") return;
    fetchSMSCDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const fetchUserDropdown = async () => {
    userDropDown({ user_type: "4" })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const userOptions = response.data.data.items.map((user) => ({
            value: user.id,
            label: user.vendor_name,
          }));
          setUsers(userOptions);
        } else {
          setUsers([]);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setUsers([]);
        console.error("Error fetching user data", error);
      });
  };

  const fetchSMSCDropdown = async () => {
    setSmscId("");
    smscDropDown({ vendor_id: user?.value })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const userOptions = response.data.data.queryData.map((user) => ({
            value: user.id,
            label: user.smsc_id,
          }));
          setSmscOptions(userOptions);
        } else {
          setSmscOptions([]);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setSmscOptions([]);
        console.error("Error fetching user data", error);
      });
  };

  const fetchCountries = async () => {
    try {
      const response = await getCountries({ cname: "" });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.countries.map((item) => ({
          value: item.name,
          label: `${item.name} (${item.dialCode})`,
        }));
        setCountryOptions(options);
      } else if (response.data.error) {
        console.error("API returned an error:", response.data.msg);
        setCountryOptions([]);
      }
    } catch (error) {
      setCountryOptions([]);
      console.error("Error fetching country data:", error);
    }
  };

  const refreshFields = () => {
    setUser(null);
    setSelectedCountry(null);
    setContCode("");
    setCost("");
    setSprice("");
    setNetwork("");
    setMnc("");
    setMcc("");
    setSmscId(null);
    setFile(null);
    setSelectErrors({
      user: false,
      smscId: false,
      country: false,
      cost: false,
      sprice: false,
      contCode: false,
      network: false,
      mcc: false,
      mnc: false,
      file: false,
    });
    setValidated(false);
  };

  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  const handleRateForm = (e) => {
    const { name, files } = e.target;
    if (name === "file") {
      setFile(files[0]);
      setSelectErrors(prev => ({
        ...prev,
        file: false
      }));
    }
  };

  const [createRate] = useCreateSMSCRateMutation();

  const validateForm = () => {
    const errors = {
      user: !user,
      smscId: !smscId,
      country: isManual && !selectedCountry,
      cost: isManual && (!cost || cost === ""),
      sprice: isManual && (!sprice || sprice === ""),
      contCode: isManual && (!contCode || contCode === ""),
      network: isManual && (!network || network === ""),
      mcc: isManual && (!mcc || mcc === ""),
      mnc: isManual && (!mnc || mnc === ""),
      file: !isManual && !file,
    };

    setSelectErrors(errors);
    return !Object.values(errors).some(error => error);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isFormValid = validateForm();

    if (!isFormValid) {
      setValidated(true);
      return;
    }

    const formData = new FormData();
    formData.append("reqType", isManual ? "manual" : "file");
    formData.append("vendor", user.label);

    if (isManual) {
      formData.append("smsc", smscId.label);
      formData.append("country", selectedCountry.value);
      formData.append("country_code", contCode);
      formData.append("cost_price", cost);
      formData.append("sell_cost", sprice); // Uncomment if needed
      formData.append("userchain", userObject.user_chain || "");
      formData.append("network", network);
      formData.append("mcc", mcc);
      formData.append("mnc", mnc);
    } else {
      formData.append("file", file);
      formData.append("smsc", smscId.label);
      formData.append("userchain", userObject.user_chain);
    }

    createRate(formData)
      .then((success) => {
        if (success?.data?.statusCode === 200) {
          setToastMessage(success?.data?.message);
          setToastVariant("success");
          setRefreshFileField(true);
          refreshFields();
          setTimeout(() => {
            history.push(Routes.SMSCRates.path);
          }, 2000);
        } else if (success?.data?.statusCode > 300) {
          setToastMessage(success?.data?.message || "Creation failed!");
          setToastVariant("danger");
        }
        setShowToast(true);
      })
      .catch((error) => {
        console.error("Login failed", error);
        setToastMessage(error?.data?.message || "Creation failed!");
        setToastVariant("danger");
        setShowToast(true);
      });

    setValidated(true);
  };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Card border={1} className="mb-3">
        <Card.Body className="p-0">
          <Form autoComplete="off" noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="toggle-switch-container d-flex justify-content-start mb-4">
              <div className="custom-toggle-switch">
                <button type="button"
                  className={`toggle-btn ${!isManual ? "active" : ""}`}
                  onClick={() => {
                    setIsManual(false);
                    setValidated(false);
                    setSelectErrors({
                      user: false,
                      smscId: false,
                      country: false,
                      cost: false,
                      sprice: false,
                      contCode: false,
                      network: false,
                      mcc: false,
                      mnc: false,
                      file: false,
                    });
                  }}
                >
                  File
                </button>
                <button type="button"
                  className={`toggle-btn ${isManual ? "active" : ""}`}
                  onClick={() => {
                    setIsManual(true);
                    setValidated(false);
                    setSelectErrors({
                      user: false,
                      smscId: false,
                      country: false,
                      cost: false,
                      sprice: false,
                      contCode: false,
                      network: false,
                      mcc: false,
                      mnc: false,
                      file: false,
                    });
                  }}
                >
                  Manual
                </button>
              </div>
            </div>
            <input
              type="text"
              name="preventAutoFill"
              style={{ display: "none" }}
            />

            <Row>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="userType">
                  <RequiredLabel label="Select Vendor" />
                  <Select
                    options={users}
                    placeholder="Select Vendor"
                    className="mb-0"
                    isSearchable={true}
                    value={user}
                    onChange={(selectedOption) => {
                      setUser(selectedOption);
                      setSelectErrors(prev => ({
                        ...prev,
                        user: false
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && selectErrors.user ? '#dc3545' : validated && !selectErrors.user ? '#65BB82': provided.borderColor,
                        borderRadius: '0.75rem',
                      }),
                    }}
                  />
                  {validated && selectErrors.user && (
                    <div className="invalid-feedback d-block">
                      Vendor selection is required.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="smscid">
                  <RequiredLabel label="SMSC ID" />
                  <Select
                    options={smscOptions}
                    placeholder="Select SMSC-ID"
                    className="mb-0"
                    isSearchable={true}
                    value={smscId}
                    onChange={(selectedOption) => {
                      setSmscId(selectedOption);
                      setSelectErrors(prev => ({
                        ...prev,
                        smscId: false
                      }));
                    }}  
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && selectErrors.smscId ? '#dc3545' : validated && !selectErrors.smscId ? '#65BB82': provided.borderColor,
                        borderRadius: '0.75rem',
                      }),
                    }}  
                  />
                  {validated && selectErrors.smscId && (
                    <div className="invalid-feedback d-block">
                      SMSC-ID selection is required.
                    </div>
                  )}
                </Form.Group>
              </Col>

              {!isManual ? (
                <Col xs={12} md={6} lg={4} className="p-0 px-2">
                  <a
                    href={`${process.env.REACT_APP_API_PORT}/download_smsc_rate_list`}
                  >
                    <u>
                      &#42;Click here to <b>download</b> Sample File.
                    </u>
                  </a>
                  <DropFilesForm
                    key={refreshFileField}
                    onFilesUploaded={handleRateForm}
                  />
                  {validated && selectErrors.file && (
                    <div className="invalid-feedback d-block">
                      File upload is required.
                    </div>
                  )}
                </Col>
              ) : (
                <>
                  <Col md={6} lg={4} className="mb-3">
                    <Form.Group id="country">
                      <RequiredLabel label="Country" />
                      <Select
                        required
                        options={countryOptions}
                        placeholder="Select Country"
                        isSearchable={true}
                        value={selectedCountry}
                        onChange={(option) => {
                          setSelectedCountry(option);
                          setSelectErrors(prev => ({
                            ...prev,
                            country: false
                          }));
                        }}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderColor: validated && selectErrors.country ? '#dc3545' : validated && !selectErrors.country && selectedCountry ? '#65BB82': provided.borderColor,
                            borderRadius: '0.75rem',
                          }),
                        }}  
                        autoComplete="new-country"
                      />
                      {validated && selectErrors.country && (
                        <div className="invalid-feedback d-block">
                          Country selection is required.
                        </div>
                      )}
                    </Form.Group>
                  </Col>
               
                  <Col md={6} lg={4} className="mb-3">
                    <Form.Group id="cost">
                      <RequiredLabel label="Cost Price" />
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter Cost Price"
                        value={cost}
                        title="Cost must be a valid number"
                        onChange={(e) => {
                          const val = e.target.value;
                          // Allow only numbers with up to two decimal places
                          if (val === "" || /^\d+(\.\d{0,5})?$/.test(val)) {
                            setCost(val);
                            setSelectErrors(prev => ({
                              ...prev,
                              cost: false
                            }));
                          }
                        }}
                        isInvalid={validated && selectErrors.cost}
                        autoComplete="new-cost"
                      />
                      <Form.Control.Feedback type="invalid">
                        Enter a valid Cost.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6} lg={4} className="mb-3">
                    <Form.Group id="selling">
                      <RequiredLabel label="Selling Price" />
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter Selling Price"
                        value={sprice}
                        title="Selling Price must be a valid number"
                        onChange={(e) => {
                          const val = e.target.value;
                          // Allow only numbers with up to two decimal places
                          if (val === "" || /^\d+(\.\d{0,5})?$/.test(val)) {
                            setSprice(val);
                            setSelectErrors(prev => ({
                              ...prev,
                              sprice: false
                            }));
                          }
                        }}
                        isInvalid={validated && selectErrors.sprice}
                        autoComplete="new-sp"
                      />
                      <Form.Control.Feedback type="invalid">
                        Enter a valid Selling Price.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6} lg={4} className="mb-3">
                    <Form.Group id="country-code">
                      <RequiredLabel label="Country Code" />
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter Country code"
                        value={contCode}
                        title="Country code must be a valid number"
                        onChange={(e) => {
                          const val = e.target.value;
                          // Allow only numbers with up to two decimal places
                          if (val === "" || /^\d+?$/.test(val)) {
                            setContCode(val);
                          setSelectErrors(prev => ({
                            ...prev,
                            contCode: false
                          }));
                        }
                        }}
                        isInvalid={validated && selectErrors.contCode}
                        autoComplete="new-code"
                      />
                      <Form.Control.Feedback type="invalid">
                        Enter a valid Country code.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4} className="mb-3">
                    <Form.Group id="network">
                      <RequiredLabel label="Network" />
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter Network"
                        value={network}
                        title="Network must be an alphanumeric value"
                        onChange={(e) => {
                          setNetwork(e.target.value);
                          setSelectErrors(prev => ({
                            ...prev,
                            network: false
                          }));
                        }}
                        isInvalid={validated && selectErrors.network}
                        autoComplete="new-network"
                      />
                      <Form.Control.Feedback type="invalid">
                        Enter a valid Network.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
              
                  <Col md={6} lg={4} className="mb-3">
                    <Form.Group id="mcc">
                      <RequiredLabel label="MCC" />
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter MCC"
                        value={mcc}
                        title="MCC must be a valid number"
                        onChange={(e) => {
                          const val = e.target.value;
                          // Allow only numbers with up to two decimal places
                          if (val === "" || /^\d+(\.\d{0,2})?$/.test(val)) {
                            setMcc(val);
                            setSelectErrors(prev => ({
                              ...prev,
                              mcc: false
                            }));
                          }
                        }}
                        isInvalid={validated && selectErrors.mcc}
                        autoComplete="new-mcc"
                      />
                      <Form.Control.Feedback type="invalid">
                        Enter a valid MCC.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4} className="mb-3">
                    <Form.Group id="mnc">
                      <RequiredLabel label="MNC" />
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter MNC"
                        value={mnc}
                        title="MNC must be a valid number"
                        onChange={(e) => {
                          const val = e.target.value;
                          // Allow only numbers with up to two decimal places
                          if (val === "" || /^\d+(\.\d{0,2})?$/.test(val)) {
                            setMnc(val);
                            setSelectErrors(prev => ({
                              ...prev,
                              mnc: false
                            }));
                          }
                        }}
                        isInvalid={validated && selectErrors.mnc}
                        autoComplete="new-mnc"
                      />
                      <Form.Control.Feedback type="invalid">
                        Enter a valid MNC.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </>
              )}
            </Row>

            <div className="d-flex justify-content-end mt-3">
              <Button
                variant="secondary"
                className="mt-2 animate-up-2"
                type="submit"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
